import React, { Component } from "react";
import { formatToFriendlyNumber } from "../../../../../../../../util";
import { minimumViewsCountToShow, minimumCommentsCountToShow, minimumLikesCountToShow } from "../../constants.js";
class InteractionsSummary extends Component {
  render() {
    const post = this.props.post || {};
    let likesCount = (post.interactions && post.interactions.likesCount) || 0;
    likesCount = likesCount + ((post.fbMetaData && post.fbMetaData.likes) || 0);
    const commentsCount = (post.interactions && post.interactions.commentsCount) || 0;
    const viewsCount = (post.interactions && post.interactions.viewsCount) || 0;

    return (
      <div className="-interactions-results">
        <div className="-pull-left">
          {likesCount >= minimumLikesCountToShow && (
            <span className="-likes-counter">
              {formatToFriendlyNumber(likesCount)} {likesCount > 1 || likesCount === 0 ? "Likes" : "Like"}
            </span>
          )}
          {commentsCount >= minimumCommentsCountToShow && (
            <span className="-comments-counter">
              {formatToFriendlyNumber(commentsCount)}{" "}
              {commentsCount > 1 || commentsCount === 0 ? "comments" : "comment"}
            </span>
          )}
        </div>
        <div className="-pull-right">
          {viewsCount >= minimumViewsCountToShow && (
            <span className="-views-counter">{this.formatForDisplay("View", viewsCount)}</span>
          )}
        </div>
      </div>
    );
  }

  formatForDisplay(interactionType, count) {
    const plurals = {
      Like: "Likes",
      Comment: "Comments",
      View: "Views",
    };

    const friendlyNumber = formatToFriendlyNumber(count);

    return `${friendlyNumber} ${count > 1 || count === 0 ? plurals[interactionType] : interactionType}`;
  }
}

export default InteractionsSummary;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/InteractionsGroup/components/InteractionsSummary/index.js